module.exports = __webpack_public_path__ + "static/media/FF-10s-Splash.77cc0393.png";